import React from 'react';
import { BrandLogo } from '../BrandLogo';
export function ClosingSection() {
  return <section aria-labelledby="closing-title" className="slide relative flex w-full snap-start snap-always flex-col justify-center overflow-hidden border-t border-white/10 px-6 py-10 sm:px-10 lg:px-14" data-id="element-42" data-mp="rhoieda6kqxw">
      <div className="mx-auto w-full max-w-[1240px]" data-id="element-43" data-mp="hiz56xt8bunz">
        <p className="font-body text-[10px] uppercase tracking-[0.28em] text-secondary/70" data-id="element-44" data-mp="hllgn8j8qubh">
          The pitch in one sentence
        </p>
        <h2 id="closing-title" className="mt-5 max-w-4xl font-heading text-3xl leading-[1.05] text-primary sm:text-4xl lg:text-5xl" data-id="element-45" data-mp="8jc2m8orkitc">
          Turn every clinician into an invitation to discover Filtek.
        </h2>
        <p className="mt-5 max-w-2xl font-body text-sm leading-relaxed text-white/65 lg:text-base" data-id="element-46" data-mp="3uwkgceflb6cx">
          Instead of relying on HCPs to find their way into one large clinical case campaign, we
          turn each individual case into a short, compelling campaign of its own — built to travel
          across social, email, WhatsApp and congress environments and drive HCPs into the full
          Filtek clinical case experience.
        </p>

        <div className="mt-8 border-t border-white/10 pt-6" data-id="element-47" data-mp="2wqd3paxhw4r5">
          <p className="font-body text-[10px] uppercase tracking-[0.28em] text-white/35" data-id="element-48" data-mp="2wnquz7yvbj7c">
            The Snakker version
          </p>
          <p className="mt-4 font-heading text-2xl leading-tight text-white lg:text-3xl" data-id="element-49" data-mp="240mn8v8e4qrv">
            The clinical cases are the content.
            <br data-id="element-50" data-mp="1z45z4116yces" />
            <span className="text-secondary" data-id="element-51" data-mp="1z0i4eyk0fjyh">The clinicians become the media.</span>
          </p>
        </div>

        <footer className="mt-10 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-5" data-id="element-52" data-mp="290iqutd6eg6w">
          <BrandLogo width={110} height={26} className="bg-transparent" data-id="element-53" data-mp="1laod89l18nll" />
          <p className="font-body text-[10px] uppercase tracking-[0.24em] text-white/35" data-id="element-54" data-mp="1l8lhd8x7808y">
            Snakker × Solventum · Filtek Clinical Case Teasers
          </p>
        </footer>
      </div>
    </section>;
}